import { render, staticRenderFns } from "./UsecaseFrame.vue?vue&type=template&id=37369bd0&"
import script from "./UsecaseFrame.vue?vue&type=script&lang=js&"
export * from "./UsecaseFrame.vue?vue&type=script&lang=js&"
import style0 from "./UsecaseFrame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports